import React from 'react';

const IconStar = () => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-star">
    <title>Star</title>
    <rect points="12 22 22 10.5 22 15.5 12 22 2 15.5 2 8.5 12 2" />
  </svg>
);

export default IconStar;
